// Scroll-snap gallery with thumbnail buttons; thumbnails scroll the track and reflect the visible slide.
class SThumbGallery extends HTMLElement {
  #ac;
  #observer;

  connectedCallback() {
    this.#ac = new AbortController();
    const track = this.querySelector('[data-gallery-track]');
    const slides = [...this.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    if (!track || !slides.length) return;

    for (const thumb of thumbs) {
      thumb.addEventListener(
        'click',
        () => {
          const slide = slides[Number(thumb.dataset.index)];
          if (!slide) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
          this.#setCurrent(thumbs, Number(thumb.dataset.index));
        },
        { signal: this.#ac.signal }
      );
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            this.#setCurrent(thumbs, slides.indexOf(entry.target));
          }
        }
      },
      { root: track, threshold: [0.6] }
    );
    for (const slide of slides) this.#observer.observe(slide);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }

  #setCurrent(thumbs, index) {
    thumbs.forEach((thumb, i) => {
      if (i === index) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }
}

if (!customElements.get('s-thumb-gallery')) customElements.define('s-thumb-gallery', SThumbGallery);
